import React, { useEffect, useState} from "react";
import {request} from "../../helper/APIUtils";

const WsCustomerList = () => {
    const [wsClients, setWsClients] = useState(null);

    useEffect(() => {
        let params = {
            url: `/websocket/getWsClients`,
            method: "get"
        };
        request(params).then(response=>{
            setWsClients(response.data);
        }).catch(err=>{
            console.log('veriye erişirken hata oluştu',err);
        })
    }, []);

    const fields = [
        {
            label: "Customer Id",
            accessor: "customerId",
            type: "text",
            operator: "="
        },
        {
            label: "Connection Type",
            accessor: "connectionType",
            type: "text",
            operator: "="
        },
        {
            label: "Branch Id",
            accessor: "branchId",
            type: "text",
            operator: "="
        }
    ];
    return(
        <div className="row baseBackground">
            <div className="col-md-12 satirBasi">
                <div className="card-header ">
                    <h4 className="card-title">WebSocket Client Listesi</h4>
                </div>

                <div className="card-body">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Customer Id</th>
                                <th>Connection Type</th>
                                <th>Branch Id</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                        {wsClients !=null ?
                            wsClients.map((client, index) =>
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{client.customerId}</td>
                                    <td>{"WSCLIENT"}</td>
                                    <td>{client.branchId}</td>

                                </tr>
                            )
                            :
                            <tr>
                                <td colSpan={6} style={{fontSize: '13px', fontWeight: 'bold'}}>Kayıt bulunamadı.
                                </td>
                            </tr>
                        }
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    );
}

export default WsCustomerList;